class CustomBuyOptions {
    constructor() {
        this.container = document.querySelector('.l-custom-buy-options');
        if (!this.container) return;

        this.cards = this.container.querySelectorAll('.l-buy-option-card');
        this.radioButtons = this.container.querySelectorAll('.l-buy-option-radio');
        this.currentVariant = null;

        this.init();
    }

    init() {
        this.setupCardClicks();
        this.setupRadioChange();
        this.setupVariantListeners();
        this.setupPreOrderButtons();
        this.initializeSelection();
        this.getCurrentVariant();
    }

    setupPreOrderButtons() {
        const preorderButtons = this.container.querySelectorAll('button[data-pre-order-button]');

        preorderButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const addToCartId = button.getAttribute('data-add-to-cart-id');
                if (!addToCartId) {
                    console.error('[Pre-order] No addToCartId found!');
                    return;
                }

                if (button.classList.contains('loading')) return;

                button.setAttribute('aria-disabled', true);
                button.classList.add('loading');

                let quantity = 1;
                const productForm = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
                if (productForm) {
                    const qtyInput = productForm.querySelector('[name="quantity"]');
                    if (qtyInput) quantity = qtyInput.value;
                }

                const miniCartForSections = document.querySelector('mini-cart');
                const sections = miniCartForSections && typeof miniCartForSections.getSectionsToRender === 'function'
                    ? miniCartForSections.getSectionsToRender().map((section) => section.id)
                    : [];

                const formData = {
                    'items': [{
                        'id': addToCartId,
                        'quantity': parseInt(quantity) || 1
                    }]
                };
                
                if (sections.length > 0) {
                    formData.sections = sections;
                    formData.sections_url = window.location.pathname;
                }

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                })
                    .then(r => {
                        if (r.status === 422) {
                            button.classList.remove('loading');
                            button.removeAttribute('aria-disabled');

                            const miniCartForUpdate = document.querySelector('mini-cart');
                            if (miniCartForUpdate && typeof miniCartForUpdate.getSectionsToRender === 'function') {
                                const sections = miniCartForUpdate.getSectionsToRender().map((section) => section.id);
                                const cartUrl = `${window.Shopify.routes.root}?sections=${sections.join(',')}`;
                                
                                fetch(cartUrl)
                                    .then(response => response.json())
                                    .then(cartData => {
                                        this.updateMiniCartWithData(cartData, miniCartForUpdate);
                                    })
                                    .catch(err => {
                                        console.error('[Pre-order] Error fetching cart:', err);
                                        if (miniCartForUpdate && typeof miniCartForUpdate.open === 'function') {
                                            miniCartForUpdate.open();
                                        }
                                    });
                            } else {
                                const miniCartElement = document.querySelector('mini-cart');
                                if (miniCartElement && typeof miniCartElement.open === 'function') {
                                    miniCartElement.open();
                                }
                            }
                            
                            return Promise.resolve({ status: 422, handled: true });
                        }
                        
                        if (!r.ok) {
                            return r.text().then(text => {
                                throw new Error(`HTTP ${r.status}: ${text}`);
                            });
                        }
                        return r.json();
                    })
                    .then(r => {
                        if (r && r.handled) {
                            return;
                        }
                        
                        button.classList.remove('loading');
                        button.removeAttribute('aria-disabled');
                        
                        if (r.status) {
                            console.error('[Pre-order] Response has status error:', r.status, r.description);
                            return;
                        }

                        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: addToCartId,
                            });
                        }

                        const miniCartElement = document.querySelector('mini-cart');
                        
                        if (miniCartElement) {
                            if (typeof miniCartElement.renderContents === 'function') {
                                try {
                                    miniCartElement.renderContents(r);
                                } catch (err) {
                                    console.error('[Pre-order] Error calling renderContents:', err);
                                }
                            }
                            
                            setTimeout(() => {
                                if (typeof miniCartElement.open === 'function') {
                                    try {
                                        miniCartElement.open();
                                    } catch (err) {
                                        console.error('[Pre-order] Error calling open():', err);
                                    }
                                } else {
                                    const details = miniCartElement.querySelector('details');
                                    if (details) {
                                        details.setAttribute('open', 'true');
                                    }
                                    
                                    const openEvent = new CustomEvent('cart:open', { bubbles: true });
                                    miniCartElement.dispatchEvent(openEvent);
                                }
                            }, 100);
                        } else {
                            const cartDrawer = document.querySelector('cart-drawer');
                            if (cartDrawer) {
                                if (typeof cartDrawer.open === 'function') {
                                    cartDrawer.open();
                                }
                            } else {
                                this.updateMiniCartFallback();
                            }
                        }
                    })
                    .catch(err => {
                        console.error('[Pre-order] Error in fetch:', err);
                        button.classList.remove('loading');
                        button.removeAttribute('aria-disabled');
                    });
            });
        });
    }

    updateMiniCartWithData(cartData, miniCartElement) {
        if (!miniCartElement) {
            miniCartElement = document.querySelector('mini-cart');
        }
        
        if (!miniCartElement) {
            return;
        }
        
        if (cartData.sections && typeof miniCartElement.renderContents === 'function') {
            miniCartElement.renderContents(cartData);
        } else if (cartData.items) {
            const compatibleData = {
                sections: cartData.sections || {},
                items: cartData.items
            };
            if (typeof miniCartElement.renderContents === 'function') {
                miniCartElement.renderContents(compatibleData);
            }
        }
        
        if (typeof miniCartElement.open === 'function') {
            miniCartElement.open();
        } else {
            const details = miniCartElement.querySelector('details');
            if (details) {
                details.setAttribute('open', 'true');
            }
        }
    }

    updateMiniCartFallback() {
        const miniCart = document.querySelector('mini-cart');
        if (!miniCart) return;

        const sectionId = miniCart.dataset.section || 'mini-cart';
        const url = `${window.Shopify.routes.root}?section_id=${sectionId}`;

        fetch(url)
            .then(response => response.text())
            .then(text => {
                const parser = new DOMParser();
                const html = parser.parseFromString(text, 'text/html');
                const newMiniCart = html.querySelector('mini-cart');

                if (newMiniCart) {
                    miniCart.innerHTML = newMiniCart.innerHTML;

                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                        const details = cartDrawer.querySelector('details');
                        if (details && !details.hasAttribute('open')) {
                            details.setAttribute('open', 'true');
                        }
                        cartDrawer.classList.add('active');
                    }
                }
            })
            .catch(e => console.error(e));
    }

    setupCardClicks() {
        this.cards.forEach(card => {
            const header = card.querySelector('.l-buy-option-header');
            if (!header) return;

            header.addEventListener('click', (e) => {
                if (e.target.classList.contains('l-buy-option-radio')) return;

                const radio = card.querySelector('.l-buy-option-radio');
                if (radio && !radio.checked) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }

    setupRadioChange() {
        this.radioButtons.forEach(radio => {
            radio.addEventListener('change', () => {
                if (radio.checked) {
                    this.updateCardStates(radio.value);
                }
            });
        });
    }

    updateCardStates(selectedOption) {
        this.cards.forEach(card => {
            if (card.dataset.option === selectedOption) {
                card.classList.add('selected');
            } else {
                card.classList.remove('selected');
            }
        });
    }

    initializeSelection() {
        const selectedCard = this.container.querySelector('.l-buy-option-card.selected');
        if (!selectedCard) {
            const firstCard = this.cards[0];
            if (firstCard) {
                firstCard.classList.add('selected');
                const radio = firstCard.querySelector('.l-buy-option-radio');
                if (radio) radio.checked = true;
            }
        }
    }

    setupVariantListeners() {
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data && event.data.variant) {
                    this.handleVariantChange(event.data.variant);
                }
            });
        }

        document.addEventListener('variant:change', (event) => {
            if (event.detail && event.detail.variant) {
                this.handleVariantChange(event.detail.variant);
            }
        });
    }

    getCurrentVariant() {
        const productForm = document.querySelector('product-form');
        if (!productForm) return null;

        const variantInput = productForm.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return null;

        const variantSelects = document.querySelector('variant-selects');
        if (variantSelects && variantSelects.currentVariant) {
            this.currentVariant = variantSelects.currentVariant;
            this.handleVariantChange(this.currentVariant);
        }

        return this.currentVariant;
    }

    handleVariantChange(variant) {
        this.currentVariant = variant;
        const variantId = String(variant.id);

        this.updateVariantVisibility(variantId);

        this.updateInstallmentPrices(variant);

        this.updatePreOrderButtonPrices(variant);
    }

    updateVariantVisibility(variantId) {
        const variantElements = this.container.querySelectorAll('[data-variant-id]');

        variantElements.forEach(el => {
            const elVariantId = String(el.dataset.variantId || el.getAttribute('data-variant-id'));
            if (elVariantId === variantId) {
                el.classList.remove('l-hidden');
            } else {
                el.classList.add('l-hidden');
            }
        });
    }

    updateInstallmentPrices(variant) {
        const variantId = String(variant.id);

        const duePriceElements = this.container.querySelectorAll('.l-buy-option-due-price[data-variant-id]');
        duePriceElements.forEach(el => {
            const elVariantId = String(el.getAttribute('data-variant-id'));
            if (elVariantId !== variantId) return;

            const installmentPriceType = el.getAttribute('data-installment-price-type');
            let priceToUse = variant.price;

            if (installmentPriceType === 'preorder' && el.hasAttribute('data-preorder-price')) {
                const preorderPrice = parseInt(el.getAttribute('data-preorder-price'));
                if (!isNaN(preorderPrice) && preorderPrice > 0) {
                    priceToUse = preorderPrice;
                }
            }

            const monthlyPayment = priceToUse / 6;
            const formattedMonthlyPayment = this.formatMoney(monthlyPayment);
            el.textContent = formattedMonthlyPayment;
        });

        const aprElements = this.container.querySelectorAll('.l-buy-option-apr[data-variant-id]');
        aprElements.forEach(el => {
            const elVariantId = String(el.getAttribute('data-variant-id'));
            if (elVariantId !== variantId) return;

            const installmentPriceType = el.getAttribute('data-installment-price-type');
            let priceToUse = variant.price;

            if (installmentPriceType === 'preorder' && el.hasAttribute('data-preorder-price')) {
                const preorderPrice = parseInt(el.getAttribute('data-preorder-price'));
                if (!isNaN(preorderPrice) && preorderPrice > 0) {
                    priceToUse = preorderPrice;
                }
            }

            const monthlyPayment = priceToUse / 6;
            const formattedMonthlyPayment = this.formatMoney(monthlyPayment);
            el.textContent = `0% APR, 6 mo x ${formattedMonthlyPayment}/mo`;
        });
    }

    updatePreOrderButtonPrices(variant) {
        const variantId = String(variant.id);

        const preorderCard = this.container.querySelector('.l-buy-option-card[data-option="preorder"]');
        if (!preorderCard) return;

        const submitButton = preorderCard.querySelector('.product-form__submit[data-buy-button="normal"]');
        if (!submitButton) return;

        const titleElement = submitButton.querySelector('.l-product-preorder-button__title');
        if (!titleElement) return;

        let template = submitButton.dataset.buttonTemplate || titleElement.textContent;
        if (!submitButton.dataset.buttonTemplate) {
            submitButton.dataset.buttonTemplate = template;
        }

        const preorderButton = preorderCard.querySelector(`button[data-variant-id="${variantId}"][data-pre-order-button]`);

        let price = variant.price;
        let compareAtPrice = variant.compare_at_price || variant.price;

        if (preorderButton) {
            const preorderPrice = parseInt(preorderButton.getAttribute('data-preorder-price'));
            const preorderCompareAt = parseInt(preorderButton.getAttribute('data-compare-at-price'));

            if (!isNaN(preorderPrice)) price = preorderPrice;
            if (!isNaN(preorderCompareAt)) compareAtPrice = preorderCompareAt;
        }

        const reduction = compareAtPrice - price;
        const percentage = Math.floor((reduction * 100.0) / compareAtPrice);

        const formattedPrice = this.formatMoney(price);
        const formattedCompareAt = this.formatMoney(compareAtPrice);
        const formattedPercentage = `${percentage}%`;
        const formattedAmount = this.formatMoney(reduction);

        let updatedText = template
            .replace(/\[price\]/g, formattedPrice)
            .replace(/\[compare_at_price\]/g, `<s>${formattedCompareAt}</s>`)
            .replace(/\[sale_percentage\]/g, formattedPercentage)
            .replace(/\[amount\]/g, `<span data-amount>${formattedAmount}</span>`);

        updatedText = updatedText
            .replace(/<strong>\[price\]<\/strong>/g, `<strong>${formattedPrice}</strong>`)
            .replace(/<strong>\[compare_at_price\]<\/strong>/g, `<strong><s>${formattedCompareAt}</s></strong>`)
            .replace(/<strong>\[sale_percentage\]<\/strong>/g, `<strong>${formattedPercentage}</strong>`)
            .replace(/<strong>\[amount\]<\/strong>/g, `<strong data-amount>${formattedAmount}</strong>`);

        titleElement.innerHTML = updatedText;
    }

    formatMoney(cents) {
        if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
            return theme.Currency.formatMoney(cents, theme.shopSettings.moneyFormat);
        }

        const dollars = (cents / 100).toFixed(2);
        return `$${dollars}`;
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new CustomBuyOptions();
    });
} else {
    new CustomBuyOptions();
}
